<template>

    <div class="contentsComp">

        <!--<div v-if="isSpinner"
             class="skeletons">
            <div v-for="list in dataLists"
                 :key="list.boardUID">
                <div class="skeleton name"></div>
                <div class="skeleton title"></div>
                <div class="skeleton date"></div>
            </div>
        </div>-->

        <div class="newsListWrap">

            <Spinner></Spinner>

            <div class="dataListBox">
                <ul class="dataView">

                    <li v-for="list in dataLists"
                        :key="list.boardUID"
                        @click="clickNewsDetail(list.boardUID, list.subject)"
                        v-if="list.boardNo === 0"
                        class="topTopic">

                        <v-skeleton-loader 
                                           type="table-heading"
                                           :loading="loading"
                                           width="100%"
                                           :style="loading ? 'display: block' : 'display:flex'"
                                           style="display: flex; justify-content: center; width: 100%; align-items: center;">

                            <div class="boardUid">
                                <span v-if="!$vuetify.breakpoint.xs">{{ list.categoryName }}</span>
                                <span v-else
                                      v-for="icon in menuIcons"
                                      :key="icon">
                                    <font-awesome-icon :value="list.categoryBoardType"
                                                       :icon="icon[list.categoryBoardType]" />
                                </span>
                            </div>
                            <div class="subject">{{ list.subject }}</div>
                            <div class="lastDate">
                                {{ setLastUpdateDate(list.lastUpdateDate) }}
                            </div>

                        </v-skeleton-loader>
                    </li>

                    <li v-for="list in dataLists"
                        :key="list.boardUID"
                        @click="clickNewsDetail(list.boardUID, list.subject)"
                        v-if="list.boardNo != 0">
                        <v-skeleton-loader
                                           type="table-heading"
                                           :loading="loading"
                                           width="100%"
                                           :style="loading ? 'display: block' : 'display:flex'"
                                           style="display: flex; justify-content: center; width: 100%; align-items: center;">

                            <div class="boardUid">
                                <span v-if="!$vuetify.breakpoint.xs">{{ list.categoryName }}</span>
                                <span v-else
                                      v-for="icon in menuIcons"
                                      :key="icon">
                                    <font-awesome-icon :value="list.categoryBoardType"
                                                       :icon="icon[list.categoryBoardType]" />
                                </span>
                            </div>
                            <div class="subject">{{ list.subject }}</div>
                            <div class="lastDate">
                                {{ setLastUpdateDate(list.lastUpdateDate) }}
                            </div>

                        </v-skeleton-loader>

                    </li>
                </ul>
                <div class="pager">
                    <div :class="{active: nonPrevPagers,prev: true }" @click="clickPrevPager(`${$route.query.category}`, startPage - 1)">
                        <font-awesome-icon icon="fa-solid fa-caret-left" />
                    </div>
                    
                    <ul class="showPagers">
                        <!--<li v-for="pager in pagers"
                            :key="pager"
                            :value="pager"
                            :class="[pager == `${$route.query.page}` ? 'on': '']"
                            class="pagers"
                            @click="clickPager(`${$route.query.category}`, pager, $event)">
                            {{ pager }}
                        </li>-->
                        <li>
                            {{ $route.query.page }} / {{ pagers }} Page
                        </li>
                    </ul>
                    
                    <div :class="{active: nonNextPagers,next: true }" @click="clickNextPager(`${$route.query.category}`, startPage + 1)">
                        <font-awesome-icon icon="fa-solid fa-caret-right" />
                    </div>
                </div>
            </div>

            <!--<div v-else
                 class="nonData">
                News in Preparation
            </div>-->

        </div>
    </div>
</template>

<script >
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc';
    import timezone from 'dayjs/plugin/timezone';
    import Spinner from '@/components/Spinner.vue'

    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/New_York");

    export default {
        name: 'NewsList',
        components: {
            Spinner,
            dayjs
        },
        data() {
            return {
                dataLists: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
                startPage: '',
                totalPages: '',
                pagers: [],
                nonNextPagers: '',
                nonPrevPagers: '',
                onPager: '',
                lastDate: '',
                isSpinner: false,
                menuIcons: [
                     {
                        "EVENT" : 'fa-solid fa-star'
                    },
                    {
                        "NOTICE": 'fa-solid fa-bullhorn',
                    },
                    {
                        "GUIDE": 'fa-solid fa-bookmark'
                    },
                    {
                        "UPDATE": 'fa-solid fa-circle-exclamation'
                    }
                ],
                loading: true
            }
        },
        computed: {
            getChangeCategory() {
                return this.$store.getters['getCategory']
            }
        },
        watch: {
            startPage(value) {

            },
            totalPages(value) {
                this.pagers = value
            },
            getChangeCategory(value) {
                /*console.log("getChangeCategory ==> ", value)*/
                if (value !== "") {
                    this.fetchListData(value, this.$route.query.page)
                }
            },
        },
        mounted() {
            if (this.$store.state.categoryBoardType) {
                this.fetchListData(this.$store.state.categoryBoardType, this.$route.query.page)
            }
        },
        methods: {
            clickNewsDetail(news, subject) {
                if (this.$route.path == '/board') {
                    this.$router.push({
                        name: 'BoardDetail',
                        query: {
                            category: this.$store.state.categoryBoardType,
                            news: news,
                            lang: this.$store.state.lang
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'NewsDetail',
                        query: {
                            category: this.$store.state.categoryBoardType,
                            news: news,
                            lang: this.$store.state.lang
                        }
                    })
                }
            },
            fetchListData(categoryBoardType, page) {
                page = page || '1'                
                this.$apiUrl.get(`/board/gcm/${categoryBoardType}/${this.$store.state.otherLang}?pageIndex=${page}&rows=10`)
                    .then((res) => {
                        if (res.data.startPage == res.data.totalPages) {
                            this.nonNextPagers = true
                        } else {
                            this.nonNextPagers = false
                        }

                        if (res.data.startPage == 1) {
                            this.nonPrevPagers = true
                        } else {
                            this.nonPrevPagers = false
                        }

                        this.dataLists = res.data.datalist
                        this.startPage = res.data.startPage
                        this.totalPages = res.data.totalPages

                        if (this.$route.query.category != categoryBoardType || this.$route.query.page != page) {
                            if (this.$route.path == '/board') {
                                this.$router.push({
                                    name: 'BoardList',
                                    query: {
                                        category: categoryBoardType,
                                        page: page,
                                        lang: this.$store.state.lang,
                                    }
                                })
                            } else {
                                this.$router.push({
                                    name: 'NewsList',
                                    query: {
                                        category: categoryBoardType,
                                        page: page,
                                        lang: this.$store.state.lang,
                                    }
                                })
                            }
                        }

                     

                        if (res.data.datalist?.length > 0) {
                            setTimeout(() => {
                                this.loading = false
                            }, 500)
                        } 

                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            clickPager(categoryNumber, pageIndex, event) {
                this.fetchListData(categoryNumber, pageIndex)
                
            },
            clickNextPager(categoryNumber, pageIndex) {
                if (this.nonNextPagers == true) {
                    return
                }
                this.fetchListData(categoryNumber, pageIndex)
            },
            clickPrevPager(categoryNumber, pageIndex) {
                if (this.nonPrevPagers == true) {
                    return
                }
                this.fetchListData(categoryNumber, pageIndex)
            },
            setLastUpdateDate(value) {
                const date = new Date(value);

                const year = date.getFullYear()
                const month = date.getMonth()
                const day = date.getDate()
                const hours = date.getHours()
                const minutes = date.getMinutes()
                const seconds = date.getSeconds()

                const UTCDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds))

                //console.log('UTC=> ', new Date(Date.UTC(year, month, day, hours, minutes, seconds))) 
                //console.log('가공=> ', new Intl.DateTimeFormat(new Intl.DateTimeFormat().resolvedOptions().locale, { dateStyle: 'short', timeStyle: 'short' }).format(UTCDate)) 

                return new Date(Date.UTC(year, month, day, hours, minutes, seconds)).toLocaleDateString(new Intl.DateTimeFormat().resolvedOptions().locale)
            },
        }
    }
</script>

<style lang="scss" >

    @import '../../assets/scss/_variables.scss';

    .contentsComp {
        height: 100%;
        box-shadow: 0px 10px 20px 5px rgba(0,0,0,0.5);
        position: relative;
        z-index: 2;
        background: #fff;
        border: solid 1px #333;
        box-sizing: border-box;
        .skeletons {
            padding: 0;
            > div {
                display: flex;
                padding: 10px;
                align-items: center;
            }

            .skeleton {
                padding: 10px;
                background: rgba(0,0,0,0.3);
                overflow: hidden;
                position: relative;
                border-radius: 10px;
                height: 44px;

                &:after {
                    display: block;
                    clear: both;
                    content: '';
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background: linear-gradient(to right, transparent, rgba(255,255,255,0.3),transparent );
                    animation: loadings 1.5s infinite linear;
                }

                @keyframes loadings {
                    0% {
                        transform: translateX(0)
                    }

                    100% {
                        transform: translateX(300px)
                    }
                }

                &.name {
                    width: 8%;
                    height: 44px;
                }

                &.title {
                    width: 80%;
                    margin: 0 20px;
                    height: 44px;
                }

                &.date {
                    width: 10%;
                    height: 44px;
                    margin: 0;
                }
            }
        }
    }
    .newsListWrap {
        height: 100%;

        .dataListBox {
            ul.dataView {
                height: 100%;
                margin-bottom: 0;

                li {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    padding: 10px;
                    border-bottom: solid 1px rgba(0,0,0,0.3);
                    cursor: pointer;
                    transition: all 0.4s;
                    box-sizing: border-box;

                    &.topTopic {
                        background: #f9f9fa;
                        color: #151432;

                        .lastDate {
                            color: #151432;
                            text-align: left;
                        }

                        .subject {
                            font-weight: 500;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .boardUid {
                            font-weight: bold;
                            color: #fff;
                            background: #3b85bc;
                        }
                    }

                    .boardUid {
                        text-align: center;
                        border-radius: 5px;
                        color: #eee;
                        width: auto;
                        padding: 6px 2px;
                        background: #333;
                        white-space: nowrap;
                        flex-basis: 170px;
                        flex-shrink: 0;
                    }

                    .subject {
                        font-size: 16px;
                        width: 90%;
                        padding: 0 20px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .lastDate {
                        color: #333;
                        text-align: left;
                        font-size: 14px;
                        color: rgba(0,0,0,0.7);
                        flex-basis: 85px;
                        flex-shrink: 0;
                    }

                    &:hover {
                        background: rgba(38,90,136, 0.1);
                    }

                    @include mobile {
                        padding: 5px;

                        .boardUid {
                            font-size: 11px;
                            padding: 5px;
                            flex-basis: 24px;
                        }

                        .subject {
                            font-size: 12px;
                            padding: 0 5px;
                        }

                        .lastDate {
                            font-size: 10px;
                            flex-basis: 60px;
                        }
                    }
                }
            }

            .pager {
                border-top: solid 1px #000;
                display: flex;
                justify-content: center;
                align-items: center;

                .prev {
                    cursor: pointer;
                    padding: 10px 20px;
                    font-size: 30px;
                    display: flex;

                    &.active {
                        color: rgba(0,0,0,0.3);
                        cursor: auto;
                    }
                }

                .showPagers {
                    display: flex;
                    margin-bottom: 0;

                    li {
                        background: rgba(0,0,0,0.1);
                        padding: 10px 15px;
                        border-radius: 10px;
                        margin: 0 2px;
                        cursor: pointer;

                        &.on {
                            background: #265a88;
                            color: #fff;
                        }
                    }
                }

                .next {
                    cursor: pointer;
                    padding: 10px 20px;
                    font-size: 30px;
                    display: flex;

                    &.active {
                        color: rgba(0,0,0,0.3);
                        cursor: auto;
                    }
                }

                @include mobile {
                    .prev {
                        padding: 5px 10px;
                    }

                    .showPagers {

                        li {
                            padding: 5px 10px;
                            font-size: 12px;
                            border-radius: 4px;
                        }
                    }

                    .next {
                        padding: 5px 10px;
                        vertical-align: middle;
                    }
                }
            }
        }

        .nonData {
            font-size: 30px;
            font-weight: bold;
            text-align: center;
            padding: 40px 0;

            @include mobile {
                font-size: 20px;
                padding: 20px 0;
            }
        }
    }
    .dataTables {
        padding: 20px;
        height: 100%;
    }

</style>